<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="/layout/association-trends?type=2">动态要闻</router-link></li>
                <li class="currentNode"><a>{{ title }}</a></li>
            </ul>
            <div class="page-main">
                <ul class="vertical-nav">
                    <li class="rootMenu"><a>动态要闻</a></li>
                    <li><router-link to="/layout/association-trends?type=1" :class="{'active': type === '1'}">实时要闻</router-link></li>
                    <li><router-link to="/layout/association-trends?type=2" :class="{'active': type === '2'}">协会动态</router-link></li>
                    <li><router-link to="/layout/association-trends?type=3" :class="{'active': type === '3'}">通知公告</router-link></li>
                </ul>
                <div class="page-content">
                    <div class="page-content-tp">
                        <h3 v-if="pageType === 'image'">{{ title }}</h3>
                        <el-checkbox-group v-if="pageType === 'text'" v-model="pageSearch" @change="changePageSearch" class="pageSearch">
                            <el-checkbox v-for="page in pageSearchList" :label="page.label" :key="page.value">{{page.label}}</el-checkbox>
                        </el-checkbox-group>
                        <ul class="pageType">
                            <li><span class="iconfont icon-liebiao2" @click="changePageType('image')" :class="{'iconfontActive': pageType === 'image'}"></span></li>
                            <li><span class="iconfont icon-liebiao" @click="changePageType('text')" :class="{'iconfontActive': pageType === 'text'}"></span></li>
                        </ul>
                    </div>
                    <div class="page-content-btm"  v-if="pageType === 'image'">
                        <ul class="trends-list">
                            <li class="trends-item" v-for="trend in trendsList" :key="trend.Id"  @click="goDetail(trend)">
                                <img :src ="trend.ImageUrl" />
                                <div class="trends-item-btm">
                                    <div class="trends-date dt">
                                        <span class="day">{{ trend.UpdateTime | traverseDate('day') }}</span>
                                        <span class="bias">/</span>
                                        <span class="month"><i>{{ trend.UpdateTime | traverseDate('month') }} 月</i><i></i>{{ trend.UpdateTime | traverseDate('year') }}</span>
                                    </div>
                                    <div class="trends-news">
                                        <h4 class="ellipsis_one ">{{ trend.Title }}</h4>
                                        <p class="ellipsis_one">{{ trend.SubTitle }}</p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="total"
                            :current-page="currentPage"
                            :page-size="pageSize"
                            @current-change="handleCurrentChange">
                        </el-pagination>
                    </div>
                    <div class="page-content-btm"  v-if="pageType === 'text'">
                        <el-table
                            :data="tableData"
                            style="width: 100%"
                            :show-header="false"
                            class="noBorder">
                            <el-table-column
                                label=""
                                width="70">
                                <template slot-scope="scope">
                                    <span class="newsTag" :class="{'associationNews': scope.row.Description === '协会动态', 'noticeNews': scope.row.Description === '通知公告',  'currentNews': scope.row.Description === '实时要闻'}">{{ scope.row.Description }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="内容">
                                <template slot-scope="scope">
                                    <a class="table_a" @click="goDetail(scope.row)">
                                        <p class="ellipsis_one">{{ scope.row.Title }}</p>
                                    </a>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="UpdateTime"
                                label="日期"
                                width="90">
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="totalText"
                            :current-page="currentPageText"
                            :page-size="pageSizeText"
                            @current-change="handleCurrentChange">
                        </el-pagination>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import {
    getYaowen,
    getDongtaiYaowen
} from '@services/indexService.js';

export default {
    name:"",
    data() {
        return {
            pageSearchList: [{
                label: '实时要闻',
                value: 1,
            },
            {
                label: '协会动态',
                value: 2,
            },
            {
                label: '通知公告',
                value: 3,
            }],
            pageType: 'image',
            trendsList:[],
            total: 0,
            currentPage: 1,
            pageSize: 10,
            currentPageText: 1,
            totalText: 0,
            pageSizeText: 10,
            tableData: [],
            type: '', // 时事要闻1，协会动态2，协会工作3,
            title: '',
            pageSearch: [],
        }
    },
    created() {
        this.type = this.$route.query.type;
        this.pageSearch = ['协会动态', '通知公告'];
        if (this.$route.query.page) {
            this.currentPage = Number(this.$route.query.page);
        }
        this.traverseTitle();
        this.getYaowen();
        this.getYaowenText();
    },
    methods: {
        traverseTitle() {
            if (this.type === '1'){
                this.title = "实时要闻";
            } else if (this.type === '2'){
                this.title = "协会动态";
            } else if (this.type === '3') {
                this.title = "通知公告";
            }
        },
        getYaowen() {
            let params = {
                current: this.currentPage,
                size: this.pageSize,
                type: this.type
            };
            getYaowen(params).then(res => {
                if (res.Code == 1) {
                    this.trendsList = [...res.Data];
                    this.total = res.Count;
                } else {
                    this.trendsList = [];
                    this.total = 0;
                    this.$message.error("协会要问请求失败");
                }
            })
        },
        getYaowenText() {
            let params = {
                current: this.currentPageText,
                size: this.pageSizeText,
                lstType: this.pageSearch
            };
            getDongtaiYaowen(params).then(res => {
                if (res.Code == 1) {
                    this.tableData = [...res.Data];
                    this.totalText = res.Count;
                    console.log(this.totalText)
                } else {
                    this.trendsListText = [];
                    this.totalText = 0;
                    this.$message.error("协会要问请求失败");
                }
            })
        },
        handleCurrentChange(pageNum) {
            if (window.scrollY > 0) {
                window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth' // 可选，平滑滚动
            });
            }
            if (this.pageType === 'image') {
                this.currentPage = pageNum;
                this.getYaowen();
            } else {
                this.currentPageText = pageNum;
                this.getYaowenText();
            }
        },
        goDetail(data) {
            let newUrl = this.$router.resolve({
                path:'/layout/association-trends-detail',
                    query: {
                        id: data.Id,
                        type: this.pageSearchList.filter(item => item.label === data.Description)[0].value,
                        page: this.currentPage
                    }
            });
            window.open(newUrl.href, '_blank');
        },
        changePageType (pageType) {
            this.pageType = pageType;
        },
        changePageSearch() {
            console.log(this.pageSearch);
            this.currentPageText = 1;
            this.getYaowenText();
        }
    },
    watch: {
        '$route.query.type': {
            handler: function(toType, fromType){
                console.log(toType, fromType)
                if (fromType !== undefined && toType !== fromType) {
                    this.type = toType;
                    this.pageSearch = ['协会动态', '通知公告'];
                    this.pageType = 'image';
                    this.currentPage = 1;
                    this.getYaowen();
                    this.getYaowenText();
                    this.traverseTitle();
                }
            },
            // 如果需要在路由变化时立即响应，可以设置immediate为true
            immediate: true
        },
    }
}
</script>

<style scoped>
.page-content {
    padding: 30px 42px;
}
.page-content h3{
    text-align:center;
}
.trends-list{
    padding-top: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
}
.trends-item {
    width: 456px;
    margin-right: 20px;
    cursor: pointer;
}
.trends-list .trends-item:nth-child(2n) {
    margin-right:0;
}
.trends-item img {
    width: 456px;
    height: 280px;
}
.trends-item-btm{
    padding-top: 10px;
    padding-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.trends-date {
    width: 90px;
    height: 70px;
    background: #F3F3F3;
    display: flex;
    justify-content:center;
    align-items: center;
}
.trends-date .day{
    font-family: 思源黑体 CN;
    font-size: 30.86px;
    line-height: 37.03px;
    text-align: left;

}
.trends-date .bias{
    font-size: 28px;
    font-weight: 200;

}
.trends-date .month{
    font-family: Source Sans Pro;
    font-size: 10px;
    font-weight: 400;
    line-height: 12.57px;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.trends-date .month i{
    font-style: normal;
}
.trends-news {
    width: 349px;
    cursor:pointer;
}
.trends-news h4{
    font-family: 思源黑体 CN;
    font-size: 18px;
    color: #262626;
    margin-bottom: 6px;
}
.trends-news p{
    font-size: 14px;
    color: #6A6A6A;
}
.trends-news:hover h4,
.trends-news:hover p{
    color: #116EBA;
}
.page-content-tp {
    display:flex;
    justify-content: space-between;
    align-items: center;
    border-bottom:1px solid #E5E5E5;
    /* padding-bottom: 20px; */
    height: 60px;
}
.pageType {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.pageType li {
    margin-right: 10px;
}
.pageType li .iconfont {
    font-size: 24px;
    cursor: pointer;
}
.pageType li .iconfont:hover {
    color: #116EBA;
}
.pageType li .iconfont.iconfontActive {
    color: #116EBA;
}
.newsTag{
    display: inline-block;
    width: 56px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    font-size: 12px;
    color: #fff;
}
.currentNews {
    border:1px solid  #0090F0;
    color: #0090F0;
}
.noticeNews {
    border:1px solid #4CBE16;
    color: #4CBE16;
}
.associationNews {
    border:1px solid  #F7700F;
    color: #F7700F;
}
</style>
<style>
.noBorder.el-table td.el-table__cell,
.noBorder.el-table th.el-table__cell.is-leaf {
    border-bottom: none !important;
}
.noBorder.el-table td.el-table__cell .cell {
    padding-right:0 !important;
    padding-left: 0 !important;
    cursor: pointer;
}
</style>